"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PromotionsRowBlock = _interopRequireDefault(require("../block/PromotionsRowBlock"));
var _ImageCard = _interopRequireDefault(require("../block/ImageCard"));
var _Carousel = _interopRequireDefault(require("../carousels/Carousel"));
var _CtaBlock = _interopRequireDefault(require("../block/CtaBlock"));
var _helpers = require("../../utils/helpers");
require("./../../scss/blocks/PromotionRowBlock.scss");
const carouselOptions = {
  paginationType: 'dots',
  showControls: true,
  controlButtonsOffset: -4,
  controlArrowSize: 48,
  showScrollbar: false,
  startIndex: 0,
  variableHeight: true,
  title: '',
  autoplay: false,
  autoplayDelay: 3500,
  showPagination: false,
  gutterSize: 0,
  slideAspectRatio: '4/2',
  slideGap: 1.5,
  cellsPerSlide: 4,
  cellAspectRatio: 'unset',
  cellsPosition: 'flex-start',
  wrapAround: false
};
function PromotionsRowModule(_ref) {
  let {
    title = '',
    promos = [],
    handleClicks = null
  } = _ref;
  const [slides, setSlides] = (0, _react.useState)([]);
  const defaultHandleClicks = eventDetails => {
    console.log('event details:', eventDetails);
  };
  (0, _react.useEffect)(() => {
    const createSlides = async promos => {
      const slides = await promos.map(promo => {
        var _promo$overlayContent, _promo$overlayContent2, _promo$overlayContent3;
        return {
          title: "",
          layout: "ImageCard",
          props: {
            image: {
              url: promo.image.url,
              altText: promo.image.altText,
              aspectRatio: promo.image.aspectRatio
            },
            title: promo.title,
            content: promo.content,
            handleClicks: handleClicks !== null && handleClicks !== void 0 ? handleClicks : defaultHandleClicks,
            relatedResourceId: promo.id,
            overlayContent: promo !== null && promo !== void 0 && promo.overlayContent ? /*#__PURE__*/_react.default.createElement(_CtaBlock.default, {
              title: (_promo$overlayContent = promo.overlayContent) === null || _promo$overlayContent === void 0 ? void 0 : _promo$overlayContent.title,
              content: (_promo$overlayContent2 = promo.overlayContent) === null || _promo$overlayContent2 === void 0 ? void 0 : _promo$overlayContent2.content,
              cta: (_promo$overlayContent3 = promo.overlayContent) === null || _promo$overlayContent3 === void 0 ? void 0 : _promo$overlayContent3.cta
            }) : '',
            cta: promo.cta
          }
        };
      });
      setSlides(slides);
    };
    if (promos.length > 4) createSlides(promos);
  }, [promos, handleClicks]);
  if (promos.length <= 4) {
    return /*#__PURE__*/_react.default.createElement("section", {
      className: "promotions-row"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: (0, _helpers.classes)(['h2', 'promotions-row__header'])
    }, title), /*#__PURE__*/_react.default.createElement(_PromotionsRowBlock.default, {
      gap: "2rem"
    }, promos.map(promo => {
      var _promo$cta, _promo$overlayContent4, _promo$overlayContent5, _promo$overlayContent6, _promo$overlayContent7, _promo$overlayContent8, _promo$overlayContent9, _promo$overlayContent10, _promo$overlayConent;
      return /*#__PURE__*/_react.default.createElement(_ImageCard.default, {
        classname: promo === null || promo === void 0 ? void 0 : promo.classname,
        image: promo.image,
        title: promo.title,
        content: promo.content,
        cta: promo.cta,
        handleClicks: (promo === null || promo === void 0 || (_promo$cta = promo.cta) === null || _promo$cta === void 0 ? void 0 : _promo$cta.type) === 'play-video' ? handleClicks !== null && handleClicks !== void 0 ? handleClicks : defaultHandleClicks : () => true,
        relatedResourceId: promo.id,
        overlayContent: promo.overlayContent ? /*#__PURE__*/_react.default.createElement(_CtaBlock.default, {
          title: (_promo$overlayContent4 = promo.overlayContent) === null || _promo$overlayContent4 === void 0 ? void 0 : _promo$overlayContent4.title,
          content: (_promo$overlayContent5 = promo.overlayContent) === null || _promo$overlayContent5 === void 0 ? void 0 : _promo$overlayContent5.content,
          cta: (_promo$overlayContent6 = promo.overlayContent) === null || _promo$overlayContent6 === void 0 ? void 0 : _promo$overlayContent6.cta,
          titleImageUrl: (_promo$overlayContent7 = promo.overlayContent) === null || _promo$overlayContent7 === void 0 ? void 0 : _promo$overlayContent7.titleImageUrl,
          btnGradientStartColor: (_promo$overlayContent8 = promo.overlayContent) === null || _promo$overlayContent8 === void 0 ? void 0 : _promo$overlayContent8.btnGradientStartColor,
          btnGradientEndColor: (_promo$overlayContent9 = promo.overlayContent) === null || _promo$overlayContent9 === void 0 ? void 0 : _promo$overlayContent9.btnGradientEndColor,
          ctaButtonStyle: (_promo$overlayContent10 = promo.overlayContent) === null || _promo$overlayContent10 === void 0 ? void 0 : _promo$overlayContent10.ctaButtonStyle,
          type: (_promo$overlayConent = promo.overlayConent) === null || _promo$overlayConent === void 0 ? void 0 : _promo$overlayConent.type
        }) : '',
        key: "promo-image-card-".concat(Math.round(Math.random() * 10000000))
      });
    })));
  } else if (promos.length > 4 && slides.length) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
    className: ['h3', 'promotions-row__header'].join(' ')
  }, title), /*#__PURE__*/_react.default.createElement(_Carousel.default, {
    title: true,
    slides: slides,
    options: carouselOptions,
    id: "promotions-row"
  }));
}
var _default = exports.default = PromotionsRowModule;